import { ISearchBar } from '../state';
import {
  CarRentalSearchBarActionType,
  CarSearchBarActions,
  ICarRentalSearchBarState,
} from '../types/car';

export const carRentalReducer = (
  state: ISearchBar,
  action: CarSearchBarActions
): { car: ICarRentalSearchBarState } => {
  const { type, payload } = action;

  switch (type) {
    case CarRentalSearchBarActionType.SET_ALL:
      return {
        car: {
          ...state.car,
          ...payload,
        },
      };

    case CarRentalSearchBarActionType.SET_PICK_UP_LOCATION:
      return {
        car: {
          ...state.car,
          pickUpLocation: payload,
        },
      };

    case CarRentalSearchBarActionType.SET_DROP_OFF_LOCATION:
      return {
        car: {
          ...state.car,
          dropOffLocation: payload,
        },
      };

    case CarRentalSearchBarActionType.SET_PICK_UP_DATE:
      return {
        car: {
          ...state.car,
          pickUpDate: payload,
        },
      };

    case CarRentalSearchBarActionType.SET_DROP_OFF_DATE:
      return {
        car: {
          ...state.car,
          dropOffDate: payload,
        },
      };

    case CarRentalSearchBarActionType.SET_DROP_OFF_TIME:
      return {
        car: {
          ...state.car,
          dropOffTime: payload,
        },
      };

    case CarRentalSearchBarActionType.SET_PICK_UP_TIME:
      return {
        car: {
          ...state.car,
          pickUpTime: payload,
        },
      };
    case CarRentalSearchBarActionType.SET_IS_DIFFERENT_LOCATION:
      return {
        car: {
          ...state.car,
          isDifferentLocation: payload,
        },
      };
    case CarRentalSearchBarActionType.SET_ERROR:
      return {
        car: {
          ...state.car,
          errors: payload,
        },
      };

    default:
      return {
        car: {
          ...state.car,
        },
      };
  }
};
